var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 mt-10 text-center text-red-800 bg-red-200 border-2 border-red-300 rounded-lg"},[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }